/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamLangsIdQueryResponse,
  GetApiV1ExamLangsIdPathParams,
  GetApiV1ExamLangsId401,
  GetApiV1ExamLangsId404,
  GetApiV1ExamLangsId500,
} from "../../types/examEvaluationController/GetApiV1ExamLangsId.ts";

function getGetApiV1ExamLangsIdUrl(id: GetApiV1ExamLangsIdPathParams["id"]) {
  const res = { method: "GET", url: `/api/v1/exam/langs/${id}` as const };
  return res;
}

/**
 * @description Retorna os dados de um idioma de prova pelo seu identificador, para uso no formulário de edição. **(Requer Authorization para autenticação)**
 * @summary Obter idioma de prova por ID (Requer Authorization para autenticação)
 * {@link /api/v1/exam/langs/:id}
 */
export async function getApiV1ExamLangsId(
  id: GetApiV1ExamLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamLangsIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamLangsId401 | GetApiV1ExamLangsId404 | GetApiV1ExamLangsId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamLangsIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
